// src/components/SuppliersPage.jsx
import React, { useState, useMemo } from "react";
import Header from "./Header";
import Footer from "./Footer";
import SuppliersLeftPanel from "./SuppliersLeftPanel";
import SuppliersRightPanel from "./SuppliersRightPanel";
import SupplierApplicationModal from "./SupplierApplicationModal";
import { useEffect } from 'react';

const SuppliersPage = ({ setCurrentPage }) => {
     useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // 可选：平滑滚动
  }, []);
  
  const [isApplicationModalOpen, setIsApplicationModalOpen] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState("idle");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("process");

  // Mock data (可后续替换为 Directus API)
  const suppliers = [
    {
      id: 1,
      name: "云南光伏科技有限公司",
      category: "光伏组件",
      date: "2025-03-15",
      certifications: ["ISO9001", "TUV认证", "国家光伏产品认证"],
      description: "专业从事高效光伏组件研发与生产，产品转换效率行业领先，年产能达500MW，产品广泛应用于大型地面电站和分布式项目。",
      contact: "张经理 138xxxx1234",
      website: "www.ynpv.com",
      address: "云南省昆明市高新区科园路88号"
    },
    {
      id: 2,
      name: "西南储能系统集成商",
      category: "储能系统",
      date: "2025-03-20",
      certifications: ["UL认证", "CE认证", "消防认证", "储能系统安全认证"],
      description: "提供全系列储能解决方案，涵盖工商业及大型电站级应用，拥有自主研发的BMS系统和EMS平台，累计装机容量超过200MWh。",
      contact: "李总监 139xxxx5678",
      website: "www.xnenergy-storage.com",
      address: "云南省昆明市经开区云大西路39号"
    },
    {
      id: 3,
      name: "高原风能设备有限公司",
      category: "风力发电设备",
      date: "2025-04-01",
      certifications: ["ISO14001", "风电设备认证", "高原型风机专项认证"],
      description: "专注于高原型风力发电机组研发制造，产品适应云南复杂地形与气候条件，单机容量覆盖2MW-5MW，已在国内多个高原风电场成功应用。",
      contact: "王总工 137xxxx9012",
      website: "www.gaoyuan-wind.com",
      address: "云南省大理州大理市创新工业园区"
    },
    {
      id: 4,
      name: "智能电网科技（昆明）",
      category: "智能电网设备",
      date: "2025-04-05",
      certifications: ["国家电网入网许可", "信息安全认证", "智能电表计量认证"],
      description: "研发生产智能电表、配电自动化设备及能源管理系统，产品已接入云南电网多个智能配电项目，为电网智能化升级提供核心设备支持。",
      contact: "陈经理 136xxxx3456",
      website: "www.smart-grid-km.com",
      address: "云南省昆明市五华区学府路296号"
    },
    {
      id: 5,
      name: "绿色电缆制造厂",
      category: "电缆及辅材",
      date: "2025-04-10",
      certifications: ["阻燃认证", "环保认证", "新能源专用电缆认证"],
      description: "生产新能源项目专用阻燃、耐候电缆，符合国家最新标准，产品通过TUV、UL等多项国际认证，广泛应用于光伏、风电项目。",
      contact: "赵厂长 135xxxx7890",
      website: "www.green-cable.com",
      address: "云南省曲靖市麒麟区工业园区"
    },
    {
      id: 6,
      name: "新能源运维服务公司",
      category: "技术服务",
      date: "2025-04-12",
      certifications: ["运维资质一级", "安全体系认证", "ISO9001质量管理体系"],
      description: "提供光伏、风电场全生命周期运维服务，拥有专业运维团队和智能运维平台，保障电站高效运行，已服务超过50个新能源项目。",
      contact: "孙主管 134xxxx2345",
      website: "www.newenergy-oms.com",
      address: "云南省昆明市官渡区民航路400号"
    }
  ];

  const categories = [
    "all",
    "光伏组件",
    "逆变器",
    "支架",
    "箱式变压器",
    "主变压器",
    "电缆",
    "无功补偿设备",
    "高低压开关柜（开关柜）",
    "综合自动化继保设备",
    "110KV及以上气体绝缘组合电器（GIS）或户外设备（户外配电设备）",
    "储能系统",
    "ABC组件",
    "技术尽调",
  ];

  const filteredSuppliers = useMemo(() => {
    return suppliers.filter((supplier) => {
      const matchesCategory = selectedCategory === "all" || supplier.category === selectedCategory;
      const matchesSearch = supplier.name.toLowerCase().includes(searchTerm.toLowerCase());
      return matchesCategory && matchesSearch;
    });
  }, [selectedCategory, searchTerm, suppliers]);

  const openApplicationModal = () => {
    setIsApplicationModalOpen(true);
    setApplicationStatus("idle");
  };

  const closeApplicationModal = () => {
    setIsApplicationModalOpen(false);
  };

  return (
    <div>
      <Header currentPage="suppliers" setCurrentPage={setCurrentPage} />
      <main className="pt-28 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-5xl font-bold text-gray-900 mb-6">材料入围供应商</h2>
            <div className="w-40 h-1 bg-gradient-to-r from-blue-600 via-purple-600 to-emerald-600 mx-auto"></div>
            <p className="mt-4 text-xl text-gray-600 max-w-4xl mx-auto">
              以下为西航投（云南）新能源有限公司合格供应商名录，按主营业务分类展示。
            </p>
          </div>

          {/* 左右分栏 */}
          <div className="grid lg:grid-cols-3 gap-12">
            <div className="lg:col-span-1">
              <SuppliersLeftPanel
                openApplicationModal={openApplicationModal}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
            </div>
            <div className="lg:col-span-2">
              <SuppliersRightPanel
                suppliers={suppliers}
                categories={categories}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                filteredSuppliers={filteredSuppliers}
              />
            </div>
          </div>
        </div>
      </main>

      <Footer currentPage="suppliers" setCurrentPage={setCurrentPage} />

      {/* 申请表单弹窗 */}
      <SupplierApplicationModal
        isOpen={isApplicationModalOpen}
        onClose={closeApplicationModal}
        applicationStatus={applicationStatus}
        setApplicationStatus={setApplicationStatus}
        categories={categories}
      />
    </div>
  );
};

export default SuppliersPage;